module.exports = __webpack_public_path__ + "img/search_data.688088a1.png";